import styled from 'styled-components'

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`

export const InfoListWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black[3]};
`

export const Excerpt = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  hyphens: auto;
  overflow: hidden;
  word-break: break-word;
`
